export const SET_WORD_LIST_PARAMS = "SET_WORD_LIST_PARAMS";

export const FETCH_MAIN_WORD_LIST_REQUEST = "FETCH_MAIN_WORD_LIST_REQUEST";
export const FETCH_MAIN_WORD_LIST_SUCCESS = "FETCH_MAIN_WORD_LIST_SUCCESS";
export const FETCH_MAIN_WORD_LIST_FAILURE = "FETCH_MAIN_WORD_LIST_FAILURE";
